/** @format */
import React from 'react'

export function TnCs() {
  return (
    <>
      <h2>Promotion Terms and Conditions</h2>
      <strong>1 Promotion name and promotional period</strong>
      <div>
        <br />
        <ul style={{ paddingLeft: '30px', textAlign: 'left' }}>
          <li>Promotion name: Flavour Drop 2022</li>
          <li>
            Promotional period commences: 7:00pm NZDT on Monday 25 July 2022.
          </li>
          <li>
            Promotional period ends: 11:59pm NZDT on Tuesday 9 August 2022.
          </li>
        </ul>
      </div>
      <br />
      <strong>2 Offer details for this Promotion</strong>
      <br />
      <br />
      <div style={{ textAlign: 'left' }}>
        Offer: Catch 20 flavour drops within the allocated time (sixty (60)
        seconds for desktop, seventeen (17) seconds for mobile) to receive a
        unique discount code for one (1) free pack of pods. If an Eligible
        Entrant fails to catch 20 flavour drops within the allocated time (sixty
        (60) seconds for desktop, seventeen (17) seconds for mobile) by playing
        the Flavour Drop Game, and chooses not to try and beat their score, they
        will be provided with a unique discount code for free delivery on their
        next purchase from{' '}
        <a href="vuse.co.nz" target="_blank" rel="noopener noreferrer">
          vuse.co.nz
        </a>
        .
      </div>
      <ul style={{ paddingLeft: '30px', textAlign: 'left' }}>
        <li>Can this Promotion be entered more than once: No</li>
        <li>Can an Offer be claimed more than once: No</li>
        <li>
          Offer notification: Eligible entrants will be notified of their
          offering by email, once they submit their email address at the end of
          the Flavour Drop game.
        </li>
        <li>
          Claiming the Offer: An eligible entrant can claim the Offer by
          applying the unique discount code at the checkout on{' '}
          <a href="vuse.co.nz" target="_blank" rel="noopener noreferrer">
            vuse.co.nz
          </a>{' '}
          before the promotional period ends.
        </li>
      </ul>
      <br />
      <strong>3 General information about our Promotions</strong>
      <ul style={{ paddingLeft: '30px', textAlign: 'left' }}>
        <br />
        <li>
          Information on how to claim an Offer forms part of these Terms and
          Conditions. Participation in this Promotion is deemed acceptance of
          these Terms and Conditions.
        </li>
        <li>
          Eligible entrants: An eligible entrant is one person/individual (where
          each person/individual cannot create multiple accounts or email
          addresses at either{' '}
          <a href="vuse.co.nz" target="_blank" rel="noopener noreferrer">
            vuse.co.nz
          </a>
          ,{' '}
          <a href="vuse.com.au" target="_blank" rel="noopener noreferrer">
            vuse.com.au
          </a>
          , or{' '}
          <a href="vusionry.co.nz" target="_blank" rel="noopener noreferrer">
            vusionry.co.nz
          </a>{' '}
          in order to either enter this Promotion more than once or attempting
          to claim an Offer more than once). They must (a) be a smoker or a
          vaper; (b) be a New Zealand or Australian resident; (c) be aged 18
          years and over; and (d) adhere to these Terms and Conditions as well
          as the Promoter’s Terms and Conditions of Sale. Employees of the
          Promoter or the Promoter’s associated companies (and their immediate
          families - being their spouse, child or parent) and existing retailers
          of Vuse products (including their associated companies and their
          immediate families - being their spouse, child or parent), are not
          eligible entrants and therefore not able to enter this Promotion.
        </li>
        <li>
          Promoter: Vusionry and Vuse, brands of BAT (New Zealand) Limited, who
          can be contacted at PO Box 2618, Auckland 1140, New Zealand.
        </li>
        <li>
          Limitations: This Promotion cannot be used in conjunction with any
          other offer, discount, or promotion (including promotional or discount
          codes); or exchanged or redeemed for cash, credit, or another Vuse
          product. Unless otherwise specified, a maximum of one Offer is
          available for each eligible entrant.
        </li>
        <li>
          Qualifying Entry: Eligible entrants note, and agree, that: (a) to
          qualify, an eligible entrant needs to play the Flavour Drop Game
          (where the outcome is based on their skill); (b) if applicable, any
          eligible entrant in Australia, must (i) hold, and have uploaded, a
          valid doctor’s prescription for the purchase of nicotine products on{' '}
          <a href="vuse.com.au" target="_blank" rel="noopener noreferrer">
            vuse.com.au
          </a>
          ; and (ii) meet the terms of the Therapeutic Goods Administration’s
          personal importation scheme, further details on which can be found
          here:{' '}
          <a
            href="https://www.tga.gov.au/personal-importation-scheme"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.tga.gov.au/personal-importation-scheme
          </a>{' '}
          ; (c) an Offer from this Promotion cannot be used in conjunction with
          any other offer, discount, or promotion (including promotional or
          discount codes); (d) this Promotion cannot be exchanged or redeemed
          for cash, credit, or another Vuse product; and (e) this Promotion is
          only valid and available online at either{' '}
          <a href="vuse.co.nz" target="_blank" rel="noopener noreferrer">
            vuse.co.nz
          </a>
          ,{' '}
          <a href="vuse.com.au" target="_blank" rel="noopener noreferrer">
            vuse.com.au
          </a>
          , or{' '}
          <a href="vusionry.co.nz" target="_blank" rel="noopener noreferrer">
            vusionry.co.nz
          </a>
          .
        </li>
      </ul>
      <br />
      <strong>4 Entry verification</strong>
      <div style={{ textAlign: 'left' }}>
        <br />
        All entries are subject to verification by the Promoter. The Promoter
        reserves the right, at any time, to verify the validity of entries
        (including an entrant’s identity, age and place of residence) and to
        disqualify any entrant who either (a) submits an entry that is not in
        accordance with these Terms and Conditions; or (b) tampers with the
        entry process. Any misrepresentation or fraudulent information submitted
        by an entrant will disqualify the entry.
      </div>
      <br />
      <strong>5 Varying these Terms and Conditions</strong>
      <div style={{ textAlign: 'left' }}>
        <br />
        The Promoter reserves the right to vary these Terms and Conditions
        without notice, to modify, reschedule or terminate this Promotion or to
        modify or extend the closing date and criteria of this Promotion at its
        absolute discretion.
      </div>
      <br />
      <strong>6 The Promoter’s decisions and rights</strong>
      <div style={{ textAlign: 'left' }}>
        <br />
        The Promoter’s decision on all matters relating to this Promotion is
        final and binding and no correspondence will be entered into, except as
        otherwise stated in these Terms and Conditions. Failure by the Promoter
        to enforce any of its rights at any stage does not constitute a waiver
        of those rights.
      </div>
      <br />
      <strong>7 Offer(s) are not transferable</strong>
      <div style={{ textAlign: 'left' }}>
        <br />
        An Offer is not transferable for cash or credit, any other Vuse product,
        or to any person other than the winner(s).
      </div>
      <br />
      <strong>8 Costs</strong>
      <div style={{ textAlign: 'left' }}>
        <br />
        Any costs associated with accessing the Promoter’s website, Instagram
        and/or Facebook channels is the entrant’s responsibility and is
        dependent on the entrant’s internet service provider.
      </div>
      <br />
      <strong>
        9 Cancellation, termination, modification or suspension of this
        Promotion
      </strong>
      <div style={{ textAlign: 'left' }}>
        <br />
        If for any reason, any aspect of this Promotion is not capable of
        running as planned including, but not limited to, infection by computer
        virus, mobile network failure, bugs, tampering, unauthorized
        intervention, fraud, technical failure or any cause beyond the control
        of the Promoter which corrupts or affects the administration, security,
        fairness, integrity or proper conduct of this promotion, the Promoter
        may at its sole discretion cancel, terminate, modify or suspend this
        Promotion, or invalidate any affected entries.
      </div>
      <br />
      <strong>10 Application content and ownership</strong>
      <div style={{ textAlign: 'left' }}>
        <br />
        The Promoter (or its associated or affiliated companies or third parties
        who have licensed its brands to the Promotor or contributed to the
        application) owns or licenses from third parties’ certain application
        content. All such application content remains the sole property of the
        applicable content owner and is protected under all relevant copyright,
        trademark and other applicable laws. Nothing on the application should
        be construed as granting any license or right to use or distribute any
        application content, without the Promoter’s express written permission
        or that of the applicable content owner.
      </div>
      <br />
      <strong>11 Instagram and Facebook</strong>
      <div style={{ textAlign: 'left' }}>
        <br />
        Entrants must at all times comply with Instagram’s Terms of Use and
        Facebook’s Terms of Service and the House Rules for Instagram and
        Facebook. This Promotion is in no way sponsored, endorsed or
        administered by Instagram or Facebook. Any information provided by an
        entrant is provided to the Promoter and not to Instagram or Facebook.
        Entrants release Instagram and Facebook from all liability in relation
        to this promotion.
      </div>
      <br />
      <strong>12 Exclusion of liability</strong>
      <div style={{ textAlign: 'left' }}>
        <br />
        Except for any liability that cannot be excluded by law, the Promoter
        and its respective bodies corporate (including their officers, employees
        and agents), Instagram and Facebook exclude all liability whether
        arising in tort (including without limitation negligence), contract or
        otherwise for: (a) any personal injury; or (b) any loss or damage
        (including, without limitation, loss of opportunity, loss of profits or
        loss of property); whether direct or indirect, special or consequential,
        arising in any way out of or in connection with this Promotion,
        including but not limited to, where arising out of or in connection with
        the following: (c) any technical difficulties or equipment malfunction
        (whether or not under the Promoter’s control); (d) any theft,
        unauthorized access or third-party interference; (e) any entry that is
        late, lost, altered, damaged or misdirected (whether or not after
        receipt by the Promoter) due to any reason beyond the reasonable control
        of the Promoter; (f) any variation in the Offer value; (g) any tax
        liability incurred by the entrant; or (h) participation in this
        Promotion or use of the Offer.
      </div>
      <br />
      <strong>13 Promoter’s Privacy Policy</strong>
      <div style={{ textAlign: 'left' }}>
        <br />
        These Terms and Conditions are deemed to incorporate the Promoter’s{' '}
        <a
          href="https://www.vype.co.nz/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>{' '}
        and by entering this Promotion, an entrant accepts the terms and
        conditions of that Privacy Policy.
      </div>
      <br />
      <strong>14 Collection and use of personal information</strong>
      <div style={{ textAlign: 'left' }}>
        <br />
        To the extent that the Promoter collects personal information to conduct
        this Promotion it can, for this purpose, disclose such information to
        third parties, including, but not limited to regulatory authorities, or
        use such information to contact the entrant about this Promotion. Any
        entry in this Promotion is conditional on providing this information. By
        participating in the Promotion an eligible entrant: (a) grants the
        Promoter the right to use their name, character, photographs or likeness
        in connection with the Promotion and for future promotions and marketing
        purposes (and waives any claims to royalty, right or remuneration for
        such use); (b) agrees to provide the Promoter with a perpetual
        royalty-free license to use their username in any way including, but not
        limited, to: (i) the Vuse New Zealand Facebook Group page (at{' '}
        <a
          href="https://www.facebook.com/groups/vusenz/"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.facebook.com/groups/vusenz/
        </a>
        ); (ii) the Vuse New Zealand Instagram page (at{' '}
        <a
          href="https://www.instagram.com/vuse.newzealand/"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.instagram.com/vuse.newzealand/
        </a>
        ); and (iii) the Promoter's other social media platforms and websites.
        Each entrant understands that he or she has the right to access, and may
        request correction of, any of their personal information held by the
        Promoter by contacting the Promoter at{' '}
        <a href="mailto:info.nz@vuse.com">info.nz@vuse.com</a> or{' '}
        <a href="mailto:info.au@vuse.com">info.au@vuse.com</a> . All claims
        become the property of the Promoter.
      </div>
      <br />
      <strong>15 Vuse products</strong>
      <div style={{ textAlign: 'left' }}>
        <br />
        Vuse electronic cigarettes may be hazardous to health and contain
        nicotine which is addictive. Vuse products should be kept out of reach
        of children. Vuse electronic cigarettes are not suitable for use by: (a)
        persons under the age of 18; (b) persons who are allergic/sensitive to
        nicotine; (c) pregnant or breast-feeding women; (d) persons who should
        avoid using tobacco or nicotine products for medical reasons; or (e)
        persons with an unstable heart condition, severe hypertension or
        diabetes.
      </div>
      <br />
      <strong>16 Governing law</strong>
      <div style={{ paddingBottom: '30px', textAlign: 'left' }}>
        <br />
        This Promotion, and these Terms and Conditions, are governed by New
        Zealand law.
      </div>
    </>
  )
}

export default TnCs
